'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var CheckMarkIcon = require('@narvar/nth-bit-icon-check-mark');
var ControlView = require('../../ControlView/ControlView.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var CheckMarkIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckMarkIcon);

const CprefMarketingSubscribed = ({
  featureName,
  isLandscape,
  narvarProfileUrl,
  onSignUpAgainClick
}) => {
  const {
    notificationCenterSublimeManageYourPreferences,
    notificationCenterSublimeAutoOptinTitle,
    notificationCenterSublimeAutoOptinText
  } = nthHookTranslations.useTranslations();

  // Temporary translations
  const notificationCenterSmsChangeMarketingOptin = 'Update Marketing Opt-in';
  const handlePrimaryButtonClick = () => {
    window.open(`${narvarProfileUrl}/login?type=phone`);
  };
  const handleSecondaryButtonClick = () => {
    onSignUpAgainClick();
  };
  return /*#__PURE__*/React__default["default"].createElement(ControlView["default"], {
    channel: "sms",
    isLandscape: isLandscape,
    featureName: featureName,
    icon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], null),
    heading: notificationCenterSublimeAutoOptinTitle ?? undefined,
    text: notificationCenterSublimeAutoOptinText ?? undefined,
    primaryButton: {
      text: notificationCenterSublimeManageYourPreferences ?? '',
      onClick: handlePrimaryButtonClick
    },
    secondaryButton: {
      text: notificationCenterSmsChangeMarketingOptin,
      onClick: handleSecondaryButtonClick
    }
  });
};
const translationsProvider = component => nthHookTranslations.withTranslationsProvider(component, {
  translationKeys: ['notificationCenterSublimeManageYourPreferences', 'notificationCenterSublimeAutoOptinTitle', 'notificationCenterSublimeAutoOptinText']
});
var CprefMarketingSubscribed$1 = translationsProvider(CprefMarketingSubscribed);

exports["default"] = CprefMarketingSubscribed$1;
